import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
import SignUp from '../../SignUp';
import EmailAndPassword from '../../SignUp/EmailAndPassword';

export interface FooterProps {
  onSignInClose?: () => void;
  isSignInOpen?: boolean;
  setSignUpOpen?: (open: boolean) => void;
  isSignUpOpen?: boolean;
}

function Footer({
  isSignInOpen,
  onSignInClose,
  setSignUpOpen,
  isSignUpOpen,
}: FooterProps): React.ReactElement {
  // const [isSignUpOpen, setSignUpOpen] = useState(false);

  return (
    <div>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
        }}
      >
        By continuing, you agree to our&thinsp;
        <NavLink
          to="/terms-and-conditions"
          style={{
            color: '#040404',
            fontWeight: '700',
            textDecoration: 'underline',
          }}
        >
          User Agreement
        </NavLink>
      </Typography.Text>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
        }}
      >
        and acknowledge that you understand the
        <br />
        <NavLink
          to="/privacy-policy"
          style={{
            color: '#040404',
            fontWeight: '700',
            textDecoration: 'underline',
          }}
        >
          Privacy Policy.
        </NavLink>
      </Typography.Text>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
          marginTop: '20px',
        }}
      >
        Don’t have an account? &thinsp;
        {/* <NavLink to="/sign-up" style={{ color: '#040404', fontWeight: '700', textDecoration: 'underline' }}>
          Register
        </NavLink> */}
        <Button
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            setSignUpOpen?.(true);
            onSignInClose?.();
          }}
          style={{
            color: '#040404',
            fontWeight: '700',
            padding: '0',
            textDecoration: 'underline',
          }}
        >
          Register
        </Button>
        {/* <SignUp
          content={EmailAndPassword}
          isOpen={isSignUpOpen}
          onClose={() => setSignUpOpen?.(false)}
          onSignInClose={onSignInClose}
        /> */}
      </Typography.Text>
    </div>
  );
}

export default Footer;
